export * from './umpire-component-ott-hero';
